// Module
var code = "<ul></ul>";
// Exports
export default code;